import { render } from "./HelloClient.vue?vue&type=template&id=3785db36&scoped=true"
import script from "./HelloClient.vue?vue&type=script&lang=js"
export * from "./HelloClient.vue?vue&type=script&lang=js"

import "./HelloClient.vue?vue&type=style&index=0&id=3785db36&scoped=true&lang=scss"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3785db36"]])

export default __exports__